import {
  DataType as CapabilityDataType,
  Operation as CapabilityOperation,
} from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/capability.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useSchedulingLocationInfo } from './use-scheduling-location-info';

export const useGetWeaveProviderStatus = (locationId: string) => {
  const { selectedGroupId, isMultiLocation } = useSchedulingLocationInfo();
  const isParentLocation = selectedGroupId === locationId;

  const { hasIntegrationCapability: hasCreateAppointmentCapability, isLoading } =
    SchedulerV3.Helpers.useCheckIntegrationCapability(
      { type: CapabilityDataType.APPOINTMENT, operation: CapabilityOperation.CREATE },
      locationId
    );

  /*
    Show `Add Provider` button if the location does not have the capability to create an appointment (Appointment writeback). In such case we allow office to add a provider 
    (without external provider ID) as external provider ID is only required while writing back to PMS.
    OR
    Show `Add Provider` button if the location is a child location in multi-location, since the external providers reside in parent location where PMS is set-up.
  */
  return {
    canAddWeaveProvider: (!isLoading && !hasCreateAppointmentCapability) || (isMultiLocation && !isParentLocation),
    hasCreateAppointmentCapability,
    isLoading,
  };
};
